/* eslint-disable no-restricted-globals */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
import React, { Fragment, useState, useEffect, useMemo } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Table, Tooltip, Popconfirm, Dropdown, Checkbox, Select, Tag,
  Divider,
} from 'antd';
import { FilterOutlined, ControlOutlined, EditOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import Helpers from '@Apis/helpers';
import searchIcon from '@Images/icons/icon-search.png';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import { toISTDate } from '@Apis/constants';
import H3DateSelector from '@Uilib/h3DateSelector';
import TenantSelector from '@Components/Common/Selector/TenantSelector';
import SelectDepartment from '@Components/Common/SelectDepartment';
import RfqActions from '@Actions/purchase/rfq/rfqActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAnglesRight } from '@fortawesome/free-solid-svg-icons';
import PRZSelect from '../../../Common/UI/PRZSelect';
import PRZText from '../../../Common/UI/PRZText';
import useCheckPortrait from '../../../../hooks/useCheckPortrait';
import './style.scss';
import { dateRangePresets, dateRangePresetsValues, entityNameEnum, filterTypeEnums } from '../../../../apis/constants';
import UserSavedFilterViewSelector from '../../../Common/UserSavedFilterViewSelector';

const { Option } = Select;

const RfqList = ({
  user, MONEY, getRfq, getRfqLoading, rfqs, departments, history,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [keyword, setKeyword] = useState('');
  const [searchKeyword, setSearchKeyword] = useState('');
  const [isUserReady, setIsUserReady] = useState(false);
  const [fixedColumns, setFixedColumns] = useState(['RFQ_NO']);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [selectedTenant, setSelectedTenant] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [visibleColumns, setVisibleColumns] = useState(localStorage.getItem('prcz-page-columns-rfq') ? JSON.parse(localStorage.getItem('prcz-page-columns-rfq')) : {
    RFQ_NO: {
      label: 'RFQ#',
      visible: true,
    },
    LOCATION: {
      label: 'Location',
      visible: true,
    },
    CUSTOMER: {
      label: 'Customer',
      visible: true,
    },
    ITEMS: {
      label: 'Items',
      visible: true,
    },
    AMOUNT_WITHOUT_TAX: {
      label: 'Amount (Without Tax)',
      visible: false,
    },
    TAXES: {
      label: 'Taxes',
      visible: false,
    },
    AMOUNT_WITH_TAX: {
      label: 'Total Amount',
      visible: true,
    },
    CREATED_DATE: {
      label: 'Created Date',
      visible: true,
    },
    RFQ_DATE: {
      label: 'RFQ Date',
      visible: false,
    },
    REASON: {
      label: 'Reason',
      visible: false,
    },
    STATUS: {
      label: 'Status',
      visible: true,
    },
    INTERNAL_ATTACHMENTS: {
      label: 'Internal Attachments',
      visible: true,
    },
    PUBLIC_ATTACHMENTS: {
      label: 'Public Attachments',
      visible: true,
    },
  });
  const [selectedDepartment, setSelectedDepartment] = useState('');
  const [departmentLevelVisibility, setDepartmentLevelVisibility] = useState(false);
  // Saved Filter View States
  const [currentDefaultView, setCurrentDefaultView] = useState({});
  const [currentlyAppliedFilters, setCurrentlyAppliedFilters] = useState([]);
  const [selectedFilterView, setSelectedFilterView] = useState({});
  const [isUserReadyInitial, setIsUserReadyInitial] = useState(false);
  const [isUpdateFilterSate, setIsUpdateFilterSate] = useState(true);
  const [savedFilterViews, setSavedFilterViews] = useState([]);
  const [savedFilterViewsLoading, setSavedFilterViewsLoading] = useState(false);
  const [orderDateSelectedIntervalDateRangeType, setOrderDateSelectedIntervalDateRangeType] = useState('');



  const rfqStatues = [
    { value: 'DRAFT', label: 'Draft' },
    { value: 'IN_PROGRESS', label: 'In Progress' },
    { value: 'COMPLETED', label: 'Completed' },
    { value: 'CLOSED', label: 'Closed' },
    { value: 'SHORT_CLOSED', label: 'Short Closed' },
    { value: 'VOID', label: 'Void' },
  ];
  const {
    isMobile, isPortrait, isMobileAndPortrait, isMobileOrPortrait,
  } = useCheckPortrait();

  // common 
  function getFilterValueByKey({ filtersArray, key, valueOnly = true }) {
    const selectedFilter = filtersArray.find((item) => item.filter_key === key) || null;
    return valueOnly ? selectedFilter?.filter_value : selectedFilter;
  }


  function getAppliedFiltersFromURL() {
    const appliedFiltersFromURL = [
      {
        filter_key: 'keyword',
        filter_value: Helpers.getValueFromUrl('keyword') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'limit',
        filter_value: Number(Helpers.getValueFromUrl('limit') || limit),
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'status',
        filter_value: Helpers.getValueFromUrl('status') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'tenant',
        filter_value: Helpers.getValueFromUrl('tenant') ? Helpers.getValueFromUrl('tenant')?.split(',')?.map((item) => (parseInt(item))) : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'startDate',
        filter_value: Number(Helpers.getValueFromUrl('startDate')) || '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: Helpers.getValueFromUrl('order_date_type') || '',
      },
      {
        filter_key: 'endDate',
        filter_value: Number(Helpers.getValueFromUrl('endDate')) || '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: Helpers.getValueFromUrl('order_date_type') || '',
      },
    ];
    return appliedFiltersFromURL;
  }

  const initialFilterValues = useMemo(() => [
    {
      filter_key: 'keyword',
      filter_value: '',
      filter_type: filterTypeEnums.STRING,
    },
    {
      filter_key: 'limit',
      filter_value: limit,
      filter_type: filterTypeEnums.NUMBER,
    },
    {
      filter_key: 'status',
      filter_value: '',
      filter_type: filterTypeEnums.STRING,
    },
    {
      filter_key: 'tenant',
      filter_value: [user?.tenant_info?.tenant_id],
      filter_type: filterTypeEnums.ARRAY,
    },
    {
      filter_key: 'startDate',
      filter_value: '',
      filter_type: filterTypeEnums.DATE_RANGE,
      date_range_type: '',
    },
    {
      filter_key: 'endDate',
      filter_value: '',
      filter_type: filterTypeEnums.DATE_RANGE,
      date_range_type: '',
    },
  ], []);

  const systemDefaultUserView = useMemo(() => ({
    filter_id: 'system_default',
    filter_name: 'System Default View',
    entity_name: entityNameEnum.REQUEST_FOR_QUOTATION,
    filters: initialFilterValues,
    tenant_id: user?.tenant_info?.tenant_id,
    org_id: user?.user_org_id,
    user_id: user?.user_id,
    is_default: false,
    is_system_default: true,
  }), []);

  useEffect(() => {
    setSelectedFilterView(systemDefaultUserView);;
  }, []);

  useEffect(() => {
    if (savedFilterViews && isUserReadyInitial) {
      const defaultUserView = savedFilterViews.find((item) => item.is_default);

      if (defaultUserView) {
        setCurrentDefaultView(defaultUserView);
      } else {
        setCurrentDefaultView(systemDefaultUserView);
      }

      const appliedFiltersFromURL = getAppliedFiltersFromURL();

      const selectedFilterViewFromURL = Helpers.getValueFromUrl('filter_id');
      let currentSelectedView;
      if (selectedFilterViewFromURL) {
        currentSelectedView = savedFilterViews.find((item) => String(item.filter_id) === String(selectedFilterViewFromURL));
        if (!currentSelectedView) {
          currentSelectedView = systemDefaultUserView;
        }
      } else {
        currentSelectedView = defaultUserView || systemDefaultUserView;
      }

      const filterValues = (isFromURL) => {
        const currentSelectedViewFilters = currentSelectedView.filters;

        const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: filterKey }) }), {});

        const _orderDateRangeType = getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: 'startDate', valueOnly: false }).date_range_type;

        let _orderStartDate = '';
        let _orderEndDate = '';

        if (_orderDateRangeType === '' || _orderDateRangeType === dateRangePresets.CUSTOM) {
          // No action needed for empty or custom date range type
        } else {
          const date = dateRangePresetsValues(_orderDateRangeType);
          const [start, end] = date;

          _orderStartDate = start;
          _orderEndDate = end;
          filterValue.startDate = _orderStartDate;
          filterValue.endDate = _orderEndDate;
        }

        filterValue.orderDateRangeType = _orderDateRangeType;

        return filterValue;
      };

      const tempFilterValues = filterValues(selectedFilterViewFromURL);
      setSelectedFilterView(currentSelectedView);
      if (isUpdateFilterSate) {
        // common state
        setCurrentlyAppliedFilters(appliedFiltersFromURL);
        // temp state
        setCurrentPage(tempFilterValues.page || 1);
        setLimit(tempFilterValues.limit || limit);
        setSearchKeyword(tempFilterValues.keyword);
        setKeyword(tempFilterValues.keyword);
        setSelectedTenant(tempFilterValues.tenant);
        setStartDate(tempFilterValues.startDate);
        setEndDate(tempFilterValues.endDate);
        setOrderDateSelectedIntervalDateRangeType(tempFilterValues.orderDateRangeType);
        setSelectedDepartment(tempFilterValues.department);
        setSelectedStatus(tempFilterValues.status);
      }

      if (!isUserReady) setIsUserReady(true);
      if (!isUpdateFilterSate) setIsUpdateFilterSate(true);
    }
  }, [savedFilterViews, isUserReadyInitial]);


  const rfqStatusOptions = [
    { key: null, value: null, label: 'All Status' },
    ...(rfqStatues || []).map(item => ({
      key: item.value,
      value: item.value,
      label: item.label,
    })),
  ];

  const getRfqColumns = () => {
    const tableColumns = [
      {
        title: '',
        render: (record) => {
          const dateObject = new Date(record?.end_time);

          // Format time in 12-hour format
          const hours = dateObject.getHours() % 12 || 12; // Convert 24-hour to 12-hour format
          const minutes = dateObject.getMinutes().toString().padStart(2, '0');
          const ampm = dateObject.getHours() < 12 ? 'AM' : 'PM';
          const formattedTime = `${hours}:${minutes} ${ampm}`;
          return (
            <div className="mobile-list__card">
              <div className="mobile-list__card_header">
                <div className="mobile-list__card_header-left">
                  <PRZText className="mobile-list__card_item-number" text={`#${record?.rfq_number ? record.rfq_number : 'N/A'}`} />
                </div>
                <div className="mobile-list__card_header-right">
                  <PRZText
                    style={{ backgroundColor: Helpers.getStatusColor(record.status).color }}
                    text={Helpers.getStatusColor(record.status).text?.toUpperCase()}
                    className="qr__status"
                  />
                </div>
              </div>
              <div className="mobile-list__card_body">
                <div className="mobile-list__card_body-left">
                  <PRZText
                    text={`Location - ${record?.tenant_info?.tenant_name}`}
                    className="mobile-list__card_item-details"
                  />
                  <PRZText
                    text={`Created Date - ${toISTDate(record?.created_at).format('DD/MM/YYYY')}`}
                    className="mobile-list__card_item-details"
                  />
                  <PRZText
                    text={`End Date - ${toISTDate(record?.end_time).format('DD/MM/YYYY')} ${formattedTime}`}
                    className="mobile-list__card_item-details"
                  />
                </div>
                <div className="mobile-list__card_body-right">
                  <Tooltip
                    color="white"
                    placement="top"
                    title={(
                      <PRZText className="mobile-list__card_item__tooltip_text-color" text="Items" />
                    )}
                  >
                    <PRZText
                      text={record?.rfq_lines_count || 'No Items'}
                    />
                  </Tooltip>
                </div>
              </div>
              <Divider className="mobile-list__card_divider" />
              <div className="mobile-list__card_footer">
                <div className="mobile-list__card_footer-left">
                  <Tooltip
                    color="white"
                    placement="top"
                    title={(
                      <PRZText className="mobile-list__card_item__tooltip_text-color" text="Participant" />
                    )}
                  >
                    <PRZText
                      text={record?.rfq_participants?.length || 'No Participant'}
                    />
                  </Tooltip>
                </div>
              </div>
            </div>
          );
        },
        // responsive: ['xs'],
        hidden: !isMobile,
      },
      {
        title: 'RFQ #',
        render: (record) => (
          <div className="min-width-50">
            {record?.rfq_number}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.RFQ_NO?.visible ? 'display-none' : '',
        fixed: 'left',
      },
      {
        title: 'LOCATION',
        render: (record) => (
          <div className="min-width-70">
            <H3Text text={record?.tenant_info?.tenant_name} />
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.LOCATION?.visible ? 'display-none' : '',
      },
      {
        title: 'PARTICIPANT',
        render: (text, record) => (
          <div className="min-width-85">
            {record?.rfq_participants?.length || 'No Participant'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.CUSTOMER?.visible ? 'display-none' : '',
      },
      {
        title: 'ITEMS',
        render: (text, record) => (
          <div className="min-width-50">
            {record.rfq_lines_count}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.ITEMS?.visible ? 'display-none' : '',
      },
      {
        title: 'CREATED DATE',
        render: (record) => (
          <div className="min-width-85">
            {toISTDate(record?.created_at).format('DD/MM/YYYY')}
            <H3Text text={(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown')} className="table-subscript" />
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.CREATED_DATE?.visible ? 'display-none' : '',
      },
      {
        title: 'END DATE',
        render: (record) => {
          const dateObject = new Date(record?.end_time);

          // Format time in 12-hour format
          const hours = dateObject.getHours() % 12 || 12; // Convert 24-hour to 12-hour format
          const minutes = dateObject.getMinutes().toString().padStart(2, '0');
          const ampm = dateObject.getHours() < 12 ? 'AM' : 'PM';
          const formattedTime = `${hours}:${minutes} ${ampm}`;
          return (
            <div className="min-width-70">
              {`${toISTDate(record?.end_time).format('DD/MM/YYYY')} ${formattedTime}`}
            </div>
          );
        },
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.CREATED_DATE?.visible ? 'display-none' : '',
      },
      {
        title: 'STATUS',
        render: (item) => (
          <div className="qr__status min-width-70" style={{ backgroundColor: Helpers.getStatusColor(item.status).color }}>
            {Helpers.getStatusColor(item.status).text}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.STATUS?.visible ? 'display-none' : '',
      },
      {
        title: 'INTERNAL ATTACHMENTS',
        render: (text, record) => (
          <div className="min-width-100">
            {
              record?.attachments?.map((item, index) => (
                <div>
                  <a href={item?.url} target="_blank" rel="noreferrer">{`Link# ${index + 1}`}</a>
                </div>
              ))
            }
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.INTERNAL_ATTACHMENTS?.visible ? 'display-none' : '',
      },
      {
        title: 'PUBLIC ATTACHMENTS',
        render: (text, record) => (
          <div className="min-width-100">
            {
              record?.public_attachments?.map((item, index) => (
                <div>
                  <a href={item?.url} target="_blank" rel="noreferrer">{`Link# ${index + 1}`}</a>
                </div>
              ))
            }
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.PUBLIC_ATTACHMENTS?.visible ? 'display-none' : '',
      },
      {
        title: '',
        render: (text, record) => (
          <div className="list__actions">
            {/* {Helpers.getPermission(Helpers.permissionEntities.VENDORS,
              Helpers.permissionTypes.UPDATE, user) && (
              <div
                className="list__actions-button"
                onClick={() => {
                  history.push(`/purchase/rfq/update/${record?.rfq_id}`);
                }}
              >
                <EditOutlined />
              </div>
            )} */}
            <div className="list__actions-button list__actions-button-dark" style={{ width: '100%' }} onClick={() => history.push(`/purchase/rfq/view/${record?.rfq_id}`)}>
              View
            </div>
          </div>
        ),
        className: 'list__actions-column',
        fixed: 'right',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isPortrait,
      },
    ];
    return tableColumns.filter((item) => !item.hidden);
  };

  const pushParamsToUrl = (page, currentLimit, word, status, currentTenant, currentStartDate, currentEndDate, selectedDepartment, orderDateSelectedIntervalDateRangeType, selectedFilterView) => {
    let url = '';
    if (page) url += `?page=${page}`;
    if (currentLimit) url += `&limit=${currentLimit}`;
    if (word) url += `&keyword=${word}`;
    if (status) url += `&status=${status}`;
    if (currentTenant) url += `&tenant=${currentTenant}`;
    if (currentStartDate) url += `&startDate=${currentStartDate}`;
    if (currentEndDate) url += `&endDate=${currentEndDate}`;
    if (orderDateSelectedIntervalDateRangeType) url += `&order_date_type=${orderDateSelectedIntervalDateRangeType}`;
    if (selectedFilterView) url += `&filter_id=${selectedFilterView?.filter_id}`;
    history.push(url);
  };
  // useEffect(() => {
  //   if (user?.tenant_info?.org_id) {
  //     setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
  //     setLimit(Helpers.getValueFromUrl('limit') || limit);
  //     setSearchKeyword(Helpers.getValueFromUrl('keyword'));
  //     setKeyword(Helpers.getValueFromUrl('keyword'));
  //     setSelectedStatus(Helpers.getValueFromUrl('status'));
  //     setSelectedTenant(Helpers.getValueFromUrl('tenant') ? Helpers.getValueFromUrl('tenant')?.split(',')?.map((item) => (parseInt(item, 10))) : [user?.tenant_info?.tenant_id]);
  //     setStartDate(Number(Helpers.getValueFromUrl('startDate')));
  //     setEndDate(Number(Helpers.getValueFromUrl('endDate')));
  //     if (Helpers.getTenantDepartmentId(user) !== user?.tenant_info?.default_store_id && user?.tenant_info?.inventory_config?.settings?.department_wise_visibility) {
  //       setDepartmentLevelVisibility(user?.tenant_info?.inventory_config?.settings?.department_wise_visibility);
  //       setSelectedDepartment(Helpers.getValueFromUrl('department_id') || Helpers.getDepartmentId(user)?.toString());
  //     } else {
  //       setSelectedDepartment(Helpers.getValueFromUrl('department_id'));
  //     }
  //     setIsUserReady(true);
  //   }
  // }, []);

  useEffect(() => {
    if (isUserReady) {
      pushParamsToUrl(currentPage, limit, searchKeyword, selectedStatus, selectedTenant, startDate, endDate, selectedDepartment, orderDateSelectedIntervalDateRangeType, selectedFilterView);
      setCurrentlyAppliedFilters(getAppliedFiltersFromURL());
      getRfq(user?.tenant_info?.org_id, selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.REQUEST_FOR_QUOTATION, Helpers.permissionTypes.READ)?.join(','), Helpers.getValueFromUrl('page'), Helpers.getValueFromUrl('limit'), Helpers.getValueFromUrl('status'), '', Helpers.getValueFromUrl('startDate'), Helpers.getValueFromUrl('endDate'), Helpers.getValueFromUrl('keyword'), true);
    }
  }, [searchKeyword, currentPage, limit, selectedStatus, selectedTenant, selectedDepartment, startDate, endDate, orderDateSelectedIntervalDateRangeType]);

  return (
    <Fragment>
      <div className="doc-list__wrapper">
        <div className="ant-row">
          <div className="ant-col-xs-24">
            <div className="doc-list__header-wrapper">
              <div className="doc-list__header-wrapper__left">
                <div className="section-search">
                  <div className="doc-list__search-bar__wrapper">
                    <div className="section-search-bar">
                      <input
                        value={keyword}
                        placeholder="Search for RFQ..."
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            setSearchKeyword(e.target.value);
                            setCurrentPage(1);
                          }
                        }}
                        onChange={(event) => {
                          setKeyword(event.target.value);
                        }}
                      />
                      <H3Image
                        src={searchIcon}
                        className="section-search-bar__icon"
                        alt="search"
                        onClick={() => {
                          setSearchKeyword(keyword);
                          setCurrentPage(1);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="doc-list__header-wrapper__right">
                {Helpers.getPermission(Helpers.permissionEntities.REQUEST_FOR_QUOTATION,
                  Helpers.permissionTypes.CREATE, user) && (
                    <div className="doc-list__buttons-wrapper">
                      <H3Button
                        buttonType={defaultButtonTypes.BLUE_ROUNDED}
                        text="+ New RFQ"
                        onClick={() => {
                          history.push('/purchase/rfq/create');
                        }}
                        customClass="add-button"
                      />
                    </div>
                  )}
              </div>
            </div>
            <div className="flex-align-c" style={{ gap: '10px' }}>
              <UserSavedFilterViewSelector
                selectedFilterView={selectedFilterView}
                onChangeTab={(currentSelectedView) => {
                  setSelectedFilterView(() => {
                    const currentSelectedViewFilters = currentSelectedView.filters;

                    const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: filterKey }) }), {});

                    const _orderDateRangeType = getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: 'startDate', valueOnly: false }).date_range_type;

                    let _orderStartDate = '';
                    let _orderEndDate = '';

                    if (_orderDateRangeType === '' || _orderDateRangeType === dateRangePresets.CUSTOM) {
                      // No action needed for empty or custom date range type
                    } else {
                      const date = dateRangePresetsValues(_orderDateRangeType);
                      const [start, end] = date;

                      _orderStartDate = start;
                      _orderEndDate = end;
                      filterValue.startDate = _orderStartDate;
                      filterValue.endDate = _orderEndDate;
                    }

                    filterValue.orderDateRangeType = _orderDateRangeType;

                    const tempFilterValues = filterValue;
                    // common state
                    setCurrentlyAppliedFilters(currentSelectedViewFilters);
                    setOrderDateSelectedIntervalDateRangeType(tempFilterValues.orderDateRangeType);
                    // temp states
                    setKeyword(tempFilterValues.keyword);
                    setSearchKeyword(tempFilterValues.keyword);
                    setLimit(tempFilterValues.limit);
                    setCurrentPage(1);
                    setSelectedStatus(tempFilterValues.status);
                    setSelectedTenant(tempFilterValues.tenant);
                    setStartDate(tempFilterValues.startDate ? Number(tempFilterValues.startDate) : null);
                    setEndDate(tempFilterValues.endDate ? Number(tempFilterValues.endDate) : null);
                    setSelectedDepartment(tempFilterValues.department_id ? tempFilterValues.department_id : '');
                    return currentSelectedView;
                  });
                }}
                currentlyAppliedFilters={currentlyAppliedFilters}
                entityName={entityNameEnum.REQUEST_FOR_QUOTATION}
                setSavedFilterViews={(value) => setSavedFilterViews(value)}
                setSavedFilterViewsLoading={(value) => setSavedFilterViewsLoading(value)}
                setIsUpdateFilterSate={(value) => setIsUpdateFilterSate(value)}
                callback={() => {
                  if (!isUserReadyInitial) setIsUserReadyInitial(true);
                }}
                systemDefaultUserView={systemDefaultUserView}
              />
              <div className="header__tags">
                {searchKeyword && (
                  <Tag closable onClose={() => { setSearchKeyword(''); setKeyword(''); setCurrentPage(1); }} color="#2d7df7">
                    Search for
                    &nbsp;
                    <span><b>{searchKeyword}</b></span>
                  </Tag>
                )}
                {selectedStatus && (
                  <Tag closable onClose={() => { setSelectedStatus(null); setCurrentPage(1); }} color="#2d7df7">
                    Status -
                    &nbsp;
                    <span><b>{selectedStatus?.replaceAll('_', ' ')?.toUpperCase()}</b></span>
                  </Tag>
                )}
                {
                  (startDate && endDate) ? (
                    <Tag
                      closable
                      onClose={() => {
                        setStartDate(null);
                        setEndDate(null);
                        setOrderDateSelectedIntervalDateRangeType('')
                      }}
                      color="#2d7df7"
                    >
                      {' '}
                      From:
                      &nbsp;
                      <span><b>{dayjs(startDate).format('DD/MM/YYYY')}</b></span>
                      &nbsp;
                      To:
                      &nbsp;
                      <span><b>{dayjs(endDate).format('DD/MM/YYYY')}</b></span>
                    </Tag>
                  ) : ''
                }

                {selectedTenant && selectedTenant?.map((item, index) => (
                  <Tag
                    key={index}
                    closable
                    onClose={() => {
                      setCurrentPage(1);
                      setSelectedTenant(selectedTenant.filter((tId) => tId !== item));
                    }}
                    color="#2d7df7"
                  >
                    Business Unit -
                    &nbsp;
                    <span>
                      <b>{user?.user_tenants?.find((tenant) => tenant?.tenant_id == item)?.tenant_name?.toUpperCase()}</b>
                    </span>
                  </Tag>
                ))}
                {!!selectedDepartment && (
                  <Tag closable={!departmentLevelVisibility} onClose={() => { setSelectedDepartment(null); setCurrentPage(1); }} color="#2d7df7">
                    {' '}
                    Department -
                    &nbsp;
                    <span><b>{departments?.data?.result?.departments?.find((item) => Number(item?.department_id) === Number(selectedDepartment))?.department_info?.department_name?.toUpperCase()}</b></span>
                  </Tag>
                )}
              </div>
            </div>
            <div className="doc-list__table-wrapper">
              <Table
                title={() => (
                  <div className="doc-list__table-header">
                    <div className="doc-list__table-header__left">
                      <H3Text text={`${(rfqs && rfqs?.count) ? rfqs?.count : '0'} RFQ`} className="" />
                    </div>
                    <div className="doc-list__table-header__right">
                      <div className="doc-list__filter-buttons">
                        <H3DateSelector
                          selectedInterval={orderDateSelectedIntervalDateRangeType}
                          startDate={startDate}
                          endDate={endDate}
                          onDateChangeWithDateRangeType={({ date, dateRangeType }) => {
                            setStartDate(dayjs(date[0])?.startOf('day').valueOf());
                            setEndDate(dayjs(date[1])?.endOf('day').valueOf());
                            setCurrentPage(1);
                            setOrderDateSelectedIntervalDateRangeType(dateRangeType);
                          }}
                        />
                        <Dropdown
                          trigger={['click']}
                          overlay={(
                            <div className="header__filter__container">
                              <div className="header__filter__container__title">
                                Apply Filters
                              </div>
                              <div
                                className="filter__container rfq-list__header__section-status"
                              >
                                <div className="filter__title"> Select Business Unit </div>
                                <div
                                  className="rfq-list__header__section-status"
                                >
                                  <TenantSelector
                                    selectedTenant={selectedTenant}
                                    showSearch
                                    isMultiple
                                    noDropdownAlign
                                    onChange={(value) => {
                                      if (value === 'All') {
                                        setCurrentPage(1);
                                        setSelectedTenant(Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_REQUEST, Helpers.permissionTypes.READ).join(','));
                                      } else {
                                        setCurrentPage(1);
                                        setSelectedTenant(value);
                                      }
                                    }}
                                    placeholder="Select Business Unit"
                                    hideTitle
                                    includedTenants={Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_REQUEST, Helpers.permissionTypes.READ)}
                                  />
                                </div>
                              </div>
                              <div
                                className="filter__container rfq-list__header__section-status"
                              >
                                <div className="filter__title"> Order Status </div>
                                <PRZSelect
                                  value={selectedStatus}
                                  onChange={(value) => {
                                    setSelectedStatus(value);
                                    setCurrentPage(1);
                                  }}
                                  placeholder="Status"
                                  options={rfqStatusOptions}
                                />
                              </div>
                            </div>
                          )}
                        >
                          <div className="action-buttons">
                            <div className="action-button">
                              <H3Text text="Filters" className="action-button-text" />
                              <FilterOutlined />
                            </div>
                          </div>
                        </Dropdown>
                      </div>
                    </div>
                  </div>
                )}
                loading={getRfqLoading || savedFilterViewsLoading}
                showHeader
                size="small"
                scroll={!isMobileOrPortrait && rfqs && !!rfqs?.rfq_list?.length ? { x: 'max-content', y: 'calc(100dvh - 160px)' } : { x: 'max-content' }}
                sticky={!isMobileOrPortrait && rfqs && !!rfqs?.rfq_list?.length}
                columns={getRfqColumns()}
                dataSource={rfqs && rfqs?.rfq_list ? rfqs?.rfq_list : []}
                pagination={
                  {
                    defaultCurrent: currentPage,
                    current: currentPage,
                    total: rfqs ? rfqs?.count : 0,
                    pageSize: limit,
                    showTotal: (tot, range) => `${range[0]}-${range[1]} of ${tot} items`,
                    onChange: (page, pageSize) => {
                      setCurrentPage(page);
                      setLimit(pageSize);
                    },
                    position: ['bottomLeft'],
                    showSizeChanger: true,
                    pageSizeOptions: [10, 25, 50, 100],
                  }
                }
                bordered
              />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
const mapStateToProps = ({
  UserReducers, RfqReducers, DepartmentReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  getRfqLoading: RfqReducers.getRfqLoading,
  rfqs: RfqReducers.rfqs,
  departments: DepartmentReducers.departments,
});

const mapDispatchToProps = (dispatch) => ({
  getRfq: (orgId, tenantId, page, limit, status, onDate, fromDate, toDate, searchKeyword, is_list) => dispatch(RfqActions.getRfq(orgId, tenantId, page, limit, status, onDate, fromDate, toDate, searchKeyword, is_list)),
});

RfqList.propTypes = {
  user: PropTypes.func,
  getRfq: PropTypes.func,
  getRfqLoading: PropTypes.bool,
  rfqs: PropTypes.any,
  departments: PropTypes.any,
  MONEY: PropTypes.any,
  history: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(RfqList));
